//////////////////////////////////////////////////////////
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO O CARD DE PREÇO E FOTO                 //
//  DOS CARDS DE PRODUTO NA PÁGINA HOME                 //   
//                                                      //   
//  FUNCIONALIDADE: MOSTRAR CARD DOS PRODUTOS           //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/home.js                                      //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import MockPicture from  '../components/mock_picture';
import Preco from '../components/preco'

import '../assets/css/local/header.css';

function PrecoPicture(props) {


  // FUNÇAÕ DE FAVORITAR QUE FOI REMOVIDA A PEDIDO DO DEPARTAMENTO DE MARKETING
  // async function favoritar_itens(id){
  //   if(sessionStorage['login']){
  //     if(document.getElementById(id + 'heart').children[0].classList.contains('fa-heart-o')){
  //       document.getElementById(id + 'heart').children[0].classList.remove('fa-heart-o')
  //       document.getElementById(id + 'heart').children[0].classList.add('fa-heart')

  //       var dict_itens = {'usuario': sessionStorage['login'], 'loja': sessionStorage['loja']}
  //       dict_itens['favoritar'] = id
        
  //       var produtos = await api.post('add_session_db',{
  //           dict_itens
  //         }).then((response) => {
  //           return response
  //         })
  //       }

    
  //     else{
  //       document.getElementById(id + 'heart').children[0].classList.add('fa-heart-o')
  //       document.getElementById(id + 'heart').children[0].classList.remove('fa-heart')
        
  //       var dict_itens = {'usuario': sessionStorage['login'], 'loja': sessionStorage['loja']}
  //       dict_itens['remover_favoritar'] = id
        
  //       var produtos = await api.post('add_session_db',{
  //           dict_itens
  //         }).then((response) => {
  //           return response
  //         })
  //       }
  //   }
  //   else{
  //     if(sessionStorage['favoritar']){
  //       sessionStorage['favoritar'] = sessionStorage['favoritar'] +',' + id
  //     }
  //     else{
  //       sessionStorage.setItem('favoritar', id)
  //     }
  //     window.location.href = '/login'
  //   }
  // }

  // SE FOR PROMOÇÃO DEFINE ESSA DIV
  var promocao = <div class="nao-promocao mt-4">
                       
                    </div>

  if (props.props.props.preco !== props.props.props.preco_orig){

    // E TMABÉM FORMATA O PREÇO DA PROMOÇÃO (XX.Y PARA XX.YY)
    var preco = props.props.props.preco_orig.toString()

    var preco_lista = preco.split('.')
    
    if(preco_lista.length === 2){
        var cents = preco_lista[1]
        
        if(cents.length === 1){
            cents = cents + '0'
        }
        if(cents.length > 2){
            cents = cents.slice(0, 2)
        }

        preco_lista[1] = cents
    }
    else if (preco_lista.length === 1){
        cents = '00'
        preco_lista.push(cents)
    }


    var preco_final = preco_lista.join(',')

    promocao = <div class="promocao mt-4">
                  De: R$ {preco_final}
              </div>
  }

  // FUNÇAÕ DE FAVORITAR QUE FOI REMOVIDA A PEDIDO DO DEPARTAMENTO DE MARKETING
  // if(props.favs.includes(props.props.id)){
  //   var classes_fav = 'fa fa-heart fa-2x m-1'
  // }
  // else{
  //   var classes_fav = 'fa fa-heart-o fa-2x m-1'
  // }



  // DEFINE A DIV QUE MOSTRA SE O PRODUTO TEM POUCOS ITENS RESTANTES
  if (props.props.props.estoque <= 3){
    var classes = <div class="texto-center mb-2 vermelha">Poucos Itens Restantes</div>
  }

  // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
    // 'MockPicture' -> PARTE DA FOTO + BOTÕES DE VENDA NO CARD DOS PRODUTOS NA PÁGINA HOME
    // 'Preco' -> PREÇO DO CARD DOS PRODUTOS

  return (
    <div class="mb-5">

      <div class='px-1 mx-2 produto-card'>
      <MockPicture props={props.props} car={props.car} prods_car={props.prod_car} callback={props.callback} />

        <div class="center preco_carrinho mw-picture titulo-card">
          {props.props.props.detalhes.DESC_PRODUTO}
        </div>

        <div class="row col col-12 center px-0 mw-picture mx-0">
          {/* <div class="col-9 mx-0 px-0">
          </div> */}
          {/* <div class="col-3 px-0">
            <button class="btn-pqn-vrm p-0 pt-1 mr-5 pull-right h-100 w-100" id={props.props.id + "heart"} onClick={() => favoritar_itens(props.props.id)}>
            <i class={classes_fav}></i>
            </button>
          </div> */}
        </div>
        {promocao}
        <Preco props={props.props.props} id={props.props.id} />
        {classes}
      </div>

    </div>
  );
 }

  export default PrecoPicture;
  

 